import PageMeta from '@/components/feature/PageMeta';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotNews from './components/HotNews';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黑料中文网',
    url: 'https://fuxiaoxiao.cn',
    description: '黑料中文网是专注于娱乐圈黑料、明星爆料、网红内幕的中文资讯平台。汇聚最新最热的黑料内容，深度揭秘娱乐圈不为人知的真相。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://fuxiaoxiao.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料中文网',
    url: 'https://fuxiaoxiao.cn',
    description: '专注于娱乐圈黑料、明星爆料、网红内幕的中文资讯平台',
    logo: 'https://fuxiaoxiao.cn/logo.png',
  };

  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="黑料中文网 - 最新娱乐黑料爆料平台"
        description="黑料中文网是专注于娱乐圈黑料、明星爆料、网红内幕的中文资讯平台。汇聚最新最热的黑料内容，深度揭秘娱乐圈不为人知的真相，每日更新独家爆料，让你第一时间掌握圈内动态。"
        keywords="黑料中文网,娱乐黑料爆料,明星黑料内幕,网红黑料最新,娱乐圈爆料平台,独家黑料资讯,黑料爆料网站"
        canonicalUrl="https://fuxiaoxiao.cn"
        ogImage="https://readdy.ai/api/search-image?query=Dark%20red%20and%20black%20abstract%20geometric%20design%20with%20Chinese%20text%20heiliao%20entertainment%20news%20platform%20branding&width=1200&height=630&seq=og-homepage&orientation=landscape"
        schema={{ ...websiteSchema, ...orgSchema }}
      />

      <main>
        <HeroSection />
        <CategoryNav />
        <HotNews />
        <LatestArticles />
        <FAQSection />
      </main>
    </>
  );
}